import React, { createContext, useEffect, useState } from "react";

import { PropsType } from "../../interfaces/ChildrenType";

import { WebsocketContextType } from "./websocket-context.types";

const websocketData = sessionStorage.getItem("PLS-Websocket");

const initialState: WebsocketContextType = {
  websocketTexts: JSON.parse(websocketData as string) || null,

  setWebsocketTexts: () => { },
};

export const WebsocketContext = createContext(initialState);

export const WebsocketContextProvider: React.FC<PropsType> = ({ children }) => {
  const [websocketTexts, setWebsocketTexts] = useState<string[] | null>(
    initialState.websocketTexts
  );

  useEffect(() => {
    if (websocketTexts) {
      sessionStorage.setItem("PLS-Websocket", JSON.stringify(websocketTexts));
    } else {
      sessionStorage.removeItem("PLS-Websocket");
    }
  }, [websocketTexts]);

  return (
    <WebsocketContext.Provider value={{ websocketTexts, setWebsocketTexts }}>
      {children}
    </WebsocketContext.Provider>
  );
};
